import * as React from "react";
import { useState, useCallback } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import {
  Link,
  DataTable,
  NoSearchResult,
  PaginatedList,
  QueryHelper,
  SearchForm,
  HoverForHelp
} from "components/common";
import useShowRouteForEntity from "routing/hooks/useShowRouteForEntity";
import usePermissions from "hooks/usePermissions";
import useSearchFilterUsagesQuery from "search-filter/hooks/useSearchFilterUsagesQuery";
export const DEFAULT_PAGINATION = {
  per_page: 25,
  page: 1,
  count: 0,
  total: 0
};
const DEFAULT_QUERY = {
  query: "",
  per_page: 10,
  page: 1,
  sort: "title",
  order: "asc"
};
const StyledPaginatedList = styled(PaginatedList)`
  .pagination {
    margin: 0;
  }
`;
const Title = styled.div`
  display: flex;
  align-items: center;
`;
const StyledHoverForHelp = styled((props) => /* @__PURE__ */ React.createElement(HoverForHelp, { ...props }))`
  margin-left: 5px;
`;
const FilterUsagesInSearchesItem = ({ id, type, title, owner, capability }) => {
  const { isPermitted } = usePermissions();
  const { t } = useTranslation("enterprise_search");
  const hasViewPermissions = isPermitted(`view:read:${id}`);
  const entityRoute = useShowRouteForEntity(id, type);
  return /* @__PURE__ */ React.createElement("tr", { key: id }, /* @__PURE__ */ React.createElement("td", { className: "limited" }, /* @__PURE__ */ React.createElement(Title, null, hasViewPermissions ? /* @__PURE__ */ React.createElement(Link, { to: entityRoute }, title) : title, capability === "None" && /* @__PURE__ */ React.createElement(StyledHoverForHelp, { title: t("filter_usages_in_searches.missing_permissions") }, t("filter_usages_in_searches.missing_permissions_description", { type: type.toLowerCase() })))), /* @__PURE__ */ React.createElement("td", null, owner), /* @__PURE__ */ React.createElement("td", null, capability));
};
const FilterUsagesInSearches = ({ filterId }) => {
  const [filterQuery, setSearchFilter] = useState(DEFAULT_QUERY);
  const { data } = useSearchFilterUsagesQuery(filterId, filterQuery);
  const { t } = useTranslation("enterprise_search");
  const headers = [
    t("filter_usages_in_searches.search_name"),
    t("filter_usages_in_searches.owner_creator"),
    t("filter_usages_in_searches.capability")
  ];
  const handlePaginationChange = useCallback(
    (page) => {
      setSearchFilter((cur) => ({ ...cur, page }));
    },
    [setSearchFilter]
  );
  const handleSearch = useCallback(
    (newSearchQuery) => setSearchFilter((cur) => ({
      ...cur,
      page: DEFAULT_QUERY.page,
      query: newSearchQuery
    })),
    []
  );
  const handleReset = useCallback(() => handleSearch(DEFAULT_QUERY.query), [handleSearch]);
  const renderOverviewItem = useCallback(
    (entity) => /* @__PURE__ */ React.createElement(FilterUsagesInSearchesItem, { ...entity }),
    []
  );
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("p", { className: "description" }, t("filter_usages_in_searches.found_searches", { total: data.pagination.total })), /* @__PURE__ */ React.createElement(
    StyledPaginatedList,
    {
      activePage: filterQuery.page,
      totalItems: data.pagination.total,
      onChange: handlePaginationChange
    },
    /* @__PURE__ */ React.createElement(
      DataTable,
      {
        customFilter: /* @__PURE__ */ React.createElement(
          SearchForm,
          {
            onSearch: handleSearch,
            queryHelpComponent: /* @__PURE__ */ React.createElement(QueryHelper, { entityName: "search", commonFields: ["title"] }),
            onReset: handleReset,
            topMargin: 0
          }
        ),
        dataRowFormatter: renderOverviewItem,
        noDataText: /* @__PURE__ */ React.createElement(NoSearchResult, null, t("filter_usages_in_searches.no_usages")),
        headers,
        id: "shared-entities",
        rowClassName: "no-bm",
        rows: data.elements,
        sortByKey: "title"
      }
    )
  ));
};
export default FilterUsagesInSearches;
